import * as THREE from 'three';

/**
 * UVGenerator class to generate the UV coordinates for the extruded shape
 * Used when the shape has texture (eg, reeded glass)
 */
export default class EditorShapeUVGenerator {
  constructor(shape, textureScale) {
    this.shape = shape;

    this.shapeBounds = this.shape.calculateSegmentBounds();
    this.textureScale = new THREE.Vector2(textureScale.x, textureScale.y);
  }


  /**
   * Generate top face UV coordinates
   * UVs are generated to match the bounds of the shape so it's 0,0 -> 1,1
   */
  generateTopUV(geometry, vertices, indexA, indexB, indexC) {
    const a_x = vertices[ indexA * 3 ];
    const a_y = vertices[ indexA * 3 + 1 ];
    const b_x = vertices[ indexB * 3 ];
    const b_y = vertices[ indexB * 3 + 1 ];
    const c_x = vertices[ indexC * 3 ];
    const c_y = vertices[ indexC * 3 + 1 ];

    var shapeWidth = this.shapeBounds.max.x - this.shapeBounds.min.x;
    var shapeHeight = this.shapeBounds.max.y - this.shapeBounds.min.y;
    var repeatU = 1.0;
    var repeatV = 1.0;

    if(this.textureScale.x > 0)
      repeatU = shapeWidth / this.textureScale.x;
    if(this.textureScale.y > 0)
      repeatV = shapeHeight / this.textureScale.y;

    return [
      new THREE.Vector2( (a_x - this.shapeBounds.min.x) / shapeWidth * repeatU, (a_y - this.shapeBounds.min.y) / shapeHeight * repeatV),
      new THREE.Vector2( (b_x - this.shapeBounds.min.x) / shapeWidth * repeatU, (b_y - this.shapeBounds.min.y) / shapeHeight * repeatV),
      new THREE.Vector2( (c_x - this.shapeBounds.min.x) / shapeWidth * repeatU, (c_y - this.shapeBounds.min.y) / shapeHeight * repeatV)
    ];
  }


  /**
   * Generate side wall UVs
   * Not required, just uses default THREE.js code
   */
  generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[ indexA * 3 ];
    const a_y = vertices[ indexA * 3 + 1 ];
    const a_z = vertices[ indexA * 3 + 2 ];
    const b_x = vertices[ indexB * 3 ];
    const b_y = vertices[ indexB * 3 + 1 ];
    const b_z = vertices[ indexB * 3 + 2 ];
    const c_x = vertices[ indexC * 3 ];
    const c_y = vertices[ indexC * 3 + 1 ];
    const c_z = vertices[ indexC * 3 + 2 ];
    const d_x = vertices[ indexD * 3 ];
    const d_y = vertices[ indexD * 3 + 1 ];
    const d_z = vertices[ indexD * 3 + 2 ];

    if ( Math.abs( a_y - b_y ) < Math.abs( a_x - b_x ) ) {
      return [
        new THREE.Vector2( a_x, 1 - a_z ),
        new THREE.Vector2( b_x, 1 - b_z ),
        new THREE.Vector2( c_x, 1 - c_z ),
        new THREE.Vector2( d_x, 1 - d_z )
      ];
    } else {
      return [
        new THREE.Vector2( a_y, 1 - a_z ),
        new THREE.Vector2( b_y, 1 - b_z ),
        new THREE.Vector2( c_y, 1 - c_z ),
        new THREE.Vector2( d_y, 1 - d_z )
      ];
    }
  }
}